module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (186).b4de7e9a.jpg";